import { createSlice } from "@reduxjs/toolkit";
import { PerfilTaxaImpostoModel } from "../../../models/perfilTaxaImposto/perfilTaxaImpostoModel";
import { buscarPerfilTaxaImposto } from "../../../services/perfilTaxaImpostoService";
import { resetAll } from "../../actions/actions";

export interface PerfilTaxaImpostoState {
  //buscar perfil taxa imposto
  loading: boolean;
  busca: string | null;
  list: PerfilTaxaImpostoModel[];
  entity: PerfilTaxaImpostoModel;
  //internal
  listSelectEdit: any[];
  listSelect: any[];
  listaTaxaImposto: any[];
  selectRadio: any[];
  detalhesImposto: any[];
  page: string;
  modalDeletar: boolean;
}

const initialState: PerfilTaxaImpostoState = {
  //buscar perfil taxa imposto
  loading: false,
  busca: null,
  list: [],
  entity: {} as PerfilTaxaImpostoModel,
  //internal
  listSelectEdit: [],
  detalhesImposto: [],
  listaTaxaImposto: [],
  listSelect: [],
  selectRadio: [],
  page: "geral",
  modalDeletar: false,
};

export const perfilTaxaImpostoSlice = createSlice({
  name: "perfilTaxaImposto",
  initialState,
  reducers: {
    //buscar perfil taxa imposto
    setBuscaPerfilTaxaImposto: (state, action) => {
      state.busca = action.payload;
    },
    setEntityPerfilTaxaImposto: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setPagePerfilTaxaImposto: (state, action) => {
      state.page = action.payload;
    },
    setModalDeletarPerfilTaxaImposto: (state, action) => {
      state.modalDeletar = action.payload;
    },
    setDetalhesImposto: (state, action) => {
      state.detalhesImposto = action.payload;
    },
    setTaxaImposto: (state, action) => {
      state.listaTaxaImposto = action.payload;
    },
    setListSelect: (state, action) => {
      state.listSelect = action.payload;
    },
    setSelectRadio: (state, action) => {
      state.selectRadio = action.payload;
    },
    resetSelections: (state) => {
      state.detalhesImposto = [];
      state.selectRadio = [];
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar perfil taxa imposto
    builder.addCase(buscarPerfilTaxaImposto.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarPerfilTaxaImposto.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarPerfilTaxaImposto.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar perfil taxa imposto
  setBuscaPerfilTaxaImposto,
  setEntityPerfilTaxaImposto,
  //internal
  setPagePerfilTaxaImposto,
  setModalDeletarPerfilTaxaImposto,
  setDetalhesImposto,
  setTaxaImposto,
  setListSelect,
  setSelectRadio,
  resetSelections,
} = perfilTaxaImpostoSlice.actions;

export default perfilTaxaImpostoSlice.reducer;
